import { useEffect } from 'react';
import Wrapper from '@/components/wrapper';
import { getServerSideProps, getHead } from '@/utils/useHead';

export { getServerSideProps }

export default ({ menuDetail }: any) => {
  useEffect(() => {
    setTimeout(() => {
      const str = document.getElementById("reactCode")?.innerText || 'console.log()';
      eval(str)
    }, 0);
  }, [menuDetail]);
  return (
    <div>
      <Wrapper>
        <>
          {getHead(menuDetail)}
          <div dangerouslySetInnerHTML={{ __html: menuDetail?.info?.content }} />
        </>
      </Wrapper>
    </div>
  );
};
